import { PT_PRICE_DISCOUNT, PT_PRICE_STICKER, PT_PRICE_LOYALTY, PT_PRICE_BUNDLE, PT_PRICE_COMBI } from '~~/common/config/priceTypes';
import type { DeepPartial, Schema } from '~~/common/types/api';

// The function only reads optional flags off the variant, and its callers pass cart items whose
// variant is a `DeepPartial` — the parameter matches that rather than the full model.
type Variant = DeepPartial<Schema<'ProductVariantModel-default'>>;

type DeterminePriceTypeProps = {
  variant: Variant;
  isLoyaltyPriceValid: boolean;
};

export function determinePriceType ({ variant, isLoyaltyPriceValid }: DeterminePriceTypeProps) {
  if (typeof variant === 'object') {
    if (__AW_IS_SHOP__ && variant.stickerPrice) {
      return {
        priceType: PT_PRICE_STICKER,
        isApplicable: false,
      };
    }
    if (variant.loyaltyPrice) {
      return {
        priceType: PT_PRICE_LOYALTY,
        isApplicable: isLoyaltyPriceValid,
      };
    }
    if (__AW_IS_SHOP__ && variant.offerType === 'combi') {
      return {
        priceType: PT_PRICE_COMBI,
        isApplicable: false,
      };
    }
    if (__AW_IS_SHOP__ && variant.offerType === 'bundle') {
      return {
        priceType: PT_PRICE_BUNDLE,
        isApplicable: false,
      };
    }
    if (variant.offerType === 'discount') {
      return {
        priceType: PT_PRICE_DISCOUNT,
        isApplicable: true,
      };
    }
  }
  return {
    priceType: null,
    isApplicable: false,
  };
}
